// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.fees.multifamily.RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  CreateMultifamilyFeesRequestDto,
  GetMultifamilyFeesResponseDto,
  ListingAlias,
  MultiErrorsResponseDto,
  MultifamilyFeeDto,
  UpdateFeedImportedMultifamilyFeesRequestDto,
  UpdateMultifamilyFeesRequestDto,
} from '../..';

interface GetParams {
  listingAlias: ListingAlias;
}

export const RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_create_Path =
  '/api/web/v1/users/properties/fees/multifamily/create';

/**
 * Creates one or more fees for a multi family listing
 */
export const RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_create = (
  postData: CreateMultifamilyFeesRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, CreateMultifamilyFeesRequestDto, MultiErrorsResponseDto<MultifamilyFeeDto>>(
    {
      endpoint: RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_create_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_get_Path =
  '/api/web/v1/users/properties/fees/multifamily/get';

/**
 * Retrieve all fees for a given multi family listing
 */
export const RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_get = (
  getParams: GetParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetParams, never, GetMultifamilyFeesResponseDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_get_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_update_Path =
  '/api/web/v1/users/properties/fees/multifamily/update';

/**
 * Updates one or more fees for a multi family listing
 */
export const RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_update = (
  postData: UpdateMultifamilyFeesRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UpdateMultifamilyFeesRequestDto, MultiErrorsResponseDto<MultifamilyFeeDto>>(
    {
      endpoint: RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_update_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_updateFeedImportedFees_Path =
  '/api/web/v1/users/properties/fees/multifamily/updateFeedImportedFees';

/**
 * Updates name and description of a group of fees imported from feed
 */
export const RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_updateFeedImportedFees = (
  postData: UpdateFeedImportedMultifamilyFeesRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    UpdateFeedImportedMultifamilyFeesRequestDto,
    MultiErrorsResponseDto<MultifamilyFeeDto>
  >(
    {
      endpoint: RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_updateFeedImportedFees_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
